export const testClientId = "680143005320-d1c8affrja11c4nae7h9vt03pgp9e1rr.apps.googleusercontent.com";
export const prodClientId = "608888870154-m98eerenrr5uafmi0n44bfg0dq2f07rn.apps.googleusercontent.com";

export const getClientId = () => {
    if (process.env.REACT_APP_SERVER === "prod") {
        return prodClientId;
    }
    return testClientId;
};
